// auth-token.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { KeycloakAuthorizationService } from 'src/app/auth/keycloak.authorization.service';
import { X_ALLOW_ANONYMOUS } from '../constants/app.constants';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  constructor(private keycloak: KeycloakAuthorizationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // 1. Http requesty mozu byt aj na asset a vtedy ak nie sme prihlaseny nas to presmeruje na login.
    // 2. Dalej pomocou tohoto custom headera X_ALLOW_ANONYMOUS vieme odchytit kedy nechceme posielat Bearer token, 
    //    prave pri vytvarani eSigner job-u, kde backend sa spolieha na vedomost referenceCode nie na ziadny token.
    if (req.url.startsWith('./assets') || req.headers.has(X_ALLOW_ANONYMOUS)) {
      return next.handle(req);
    }

    return from(this.keycloak.getToken()).pipe(
      switchMap(token => {
        if (token) {
          const authReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
          return next.handle(authReq);
        }
        return next.handle(req);
      })
    );
  }
}
